import { useEffect, useContext, useState } from "react";
import QlikCard from "components/QlikCard";
import QlikObject from "components/QlikObject";
import GlobalContext from "GlobalContext";


export default function Details({ title , appDisclaimer , pageTitle, ExportChartFootnote, menuItemsStrings}) {
  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
  }, [pageTitle,title]);

  const { app } = useContext(GlobalContext);
  const [err, setError] = useState(null);
  const [FilterHeight, setFilterHeight] = useState(388);

/*   useEffect(() => {
    app.model.waitForOpen.promise.then(() => {
      setTimeout(async () => {
        app.model.enigmaModel.evaluate("$(=count({1}distinct [$(=$(T(fldProp_choice)))]))").then(async (reply) => {
          const DataAvailabilityNumberOfFilterRows = reply*29+40;
          console.log('DataAvailability/Number of rows: ', DataAvailabilityNumberOfFilterRows);
          setFilterHeight(DataAvailabilityNumberOfFilterRows);
        }).catch(err => {
          if(!err) setError(err);
        });
      }, 500);
    });
  }, [app, err]) */

  return (
    <section className="content">
      <div className="content-header">
        <div className="row mb-2">
          <div className="col-md-10 col-sm-9 col-10">
            <h5 className="page-title"> {title} </h5>
            {/* <h6 className="page-disclaimer"> {appDisclaimer} </h6> */}
          </div>
        </div>
      </div>

      <div className="container-fluid">

        <div className="row justify-content-start">

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">

              <div className="row justify-content-left">
                {/* Table Row */}
                    <div className="col-12">
                      {/* table */}
                      <QlikCard
                        id="PCafm"
                        // height="383px"
                        //height="max(calc(100vh - 263px)/2 + 42px, 150px)" 
                        height="max(calc(100vh - 263px - 60px + 90px + 10px), 150px)"
                        showHeader={true}
                        showMaximize={false}
                        //showExport={menuItemsStrings.containerTabSelector != '-1'}
                        showExport={false}
                        onBeforeExportHandler={async ({  }) => {
                          //console.log(data);
                            await app.variable.setStringValue('export_link', '1');
                        }}
                        onAfterExportHandler={async ({  }) => {
                            app.variable.setStringValue('export_link', '0');
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                      />
                    </div>
               
              </div>

            </div>

          </div>

{/*           <div className="row">
            <div className="col-12">
              <QlikObject
                id="5c60045d-6334-4b9c-aeb4-cd67221615cb"
                height="0px"
                showLoader={false}
                showOverlayer={false}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <QlikObject
                id="NMpWSe"
                height="0px"
                showLoader={false}
                showOverlayer={false}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <QlikObject
                id="NMpWSe"
                height="0px"
                showLoader={false}
                showOverlayer={false}
              />
            </div>
          </div> */}
          
        </div>
    </section>
  );
}
